import { Text } from "../Text"
import { RadioButton } from "./RadioButton"
import styles from "./RadioCard.module.css"
import { RadioItem } from "./RadioItem"

export interface RadioCardProps {
  value: string
  title: string
  disabled?: boolean
  grow?: boolean
}

export function RadioCard(props: RadioCardProps) {
  const { title, disabled = false, grow = false, value } = props

  return (
    <RadioItem disabled={disabled} grow={grow} value={value}>
      <div className={styles.root}>
        <RadioButton decorative />
        <Text variant="h4">{title}</Text>
      </div>
    </RadioItem>
  )
}
